/**
 * Created by mykurisu on 2017/12/27.
 */
let avatar_list = [
    "https://static-cos.lycheer.net/avatar/24352_94aae6a2a355b5afbf87bb7376ad96c9.jpg",
    "https://static-cos.lycheer.net/avatar/24353_a78cec3724c23e9df77a8bea025323b5.jpg",
    "https://static-cos.lycheer.net/avatar/24354_6e9ac5f9c4ee30cd29762ecefc4f3c84.jpg",
    "https://static-cos.lycheer.net/avatar/24355_9b987c7af7fe7136c0b9c1aeccdfe3d0.jpg",
    "https://static-cos.lycheer.net/avatar/24356_90cf466e63d0f4302c92b2d04cf42ebc.jpg",
    "https://static-cos.lycheer.net/avatar/24357_6f69411d68bed4b5ac4c53a183637eae.jpg",
    "https://static-cos.lycheer.net/avatar/24358_71d5719a539c49bffb545fb6083f9c96.jpg",
    "https://static-cos.lycheer.net/avatar/24359_b8b86d0c0e1161907a250f539a3c49df.jpg",
    "https://static-cos.lycheer.net/avatar/24360_27f8412d500126b924474b678ebddffb.jpg",
    "https://static-cos.lycheer.net/avatar/24361_1bb5e0f1d7429f39b4177850d508d91e.jpg",
    "https://static-cos.lycheer.net/avatar/24362_c2f57e6d1dc5fdde5dd9178dc22a480c.jpg",
    "https://static-cos.lycheer.net/avatar/24363_5d252467ba846af52ab955a5eb1cf6fb.jpg",
    "https://static-cos.lycheer.net/avatar/24364_5d5b7c45e258114b3a6badb20ecf4fa1.jpg",
    "https://static-cos.lycheer.net/avatar/24365_9a7b75377d4c023d208792d2ff5dc6be.jpg",
    "https://static-cos.lycheer.net/avatar/24366_b8403ce937f6d412e78734789f7c9cef.jpg",
    "https://static-cos.lycheer.net/avatar/24367_f3cbe60cfdaac95f8b3dfbb3a84eebe1.jpg",
    "https://static-cos.lycheer.net/avatar/24368_74558ad5c7300adeaa62df11fdc6bbbd.jpg",
    "https://static-cos.lycheer.net/avatar/24369_98cc019d8e794027268adc2eb6ef69f6.jpg",
    "https://static-cos.lycheer.net/avatar/24370_119b72f16b9723398e320c5d1e7de8cd.jpg",
    "https://static-cos.lycheer.net/avatar/24371_f183c0727e0ff03c3f25e1e30cc84a68.jpg",
    "https://static-cos.lycheer.net/avatar/24372_13098f6dd80d7874c5ec8319526b9c34.jpg",
    "https://static-cos.lycheer.net/avatar/24373_a8eb549821501883e966778a6640ba24.jpg",
    "https://static-cos.lycheer.net/avatar/24374_6906298c03d2b5e3d400741ceed59b7a.jpg",
    "https://static-cos.lycheer.net/avatar/24375_0760e07aad8943290abef725d95e00c5.jpg",
    "https://static-cos.lycheer.net/avatar/24376_992ff16f5df1388f15fa4f583c96beed.jpg",
    "https://static-cos.lycheer.net/avatar/24377_ca75631cb944ae297de2aebb82b542c8.jpg",
    "https://static-cos.lycheer.net/avatar/24378_b21887e13dc71546b7425d7e3fece95b.jpg",
    "https://static-cos.lycheer.net/avatar/24379_b6308004d6a88cc0c76fc9e84fcd1377.jpg",
    "https://static-cos.lycheer.net/avatar/24380_b11ea9153238095786c38812fc81b764.jpg",
    "https://static-cos.lycheer.net/avatar/24381_5f753f117c84a4863421bb3156dba0c2.jpg",
    "https://static-cos.lycheer.net/avatar/24382_125572505abf964edd273d5569ab08e3.jpg",
    "https://static-cos.lycheer.net/avatar/24383_cc12aca56e006a1c396eb32ea9b1a852.jpg",
    "https://static-cos.lycheer.net/avatar/24384_db46f3741360657b7fc3d1e75799eb2b.jpg",
    "https://static-cos.lycheer.net/avatar/24385_97de2dab2791fc590a574f2bccc4c3bf.jpg",
    "https://static-cos.lycheer.net/avatar/24386_921cfb7a77f3e4a9beeb28a2c58676bb.jpg",
    "https://static-cos.lycheer.net/avatar/24387_dca909b0cd3bbeaeef11c4f4a2855ef3.jpg",
    "https://static-cos.lycheer.net/avatar/24388_fbada7f5739c44e6d9c19adff8c28fb5.jpg",
    "https://static-cos.lycheer.net/avatar/24389_0545ce88f2bcac4b887887eb302d518c.jpg",
    "https://static-cos.lycheer.net/avatar/24390_fef6fbdeb967507a0e1b995550d1a61b.jpg",
    "https://static-cos.lycheer.net/avatar/24391_e7858814ab063983a80cdd78e3234f7a.jpg",
    "https://static-cos.lycheer.net/avatar/24392_2fecc323186581054e0b00ad1d063f4f.jpg",
    "https://static-cos.lycheer.net/avatar/24393_51fd31d4957ed25cbc09250dce09da43.jpg",
    "https://static-cos.lycheer.net/avatar/24394_94cd3732ad57baa4b6599e078f7f04e9.jpg",
    "https://static-cos.lycheer.net/avatar/24395_6b9c8a40881ea4f972e39a2ad56565ee.jpg",
    "https://static-cos.lycheer.net/avatar/24396_c9ef501e2f6d30406a90be0fa1d24c10.jpg",
    "https://static-cos.lycheer.net/avatar/24397_8c99bab34646a92805c028b6abb7dc4c.jpg",
    "https://static-cos.lycheer.net/avatar/24398_4550869956a801aec8d42a70eb6ddd82.jpg",
    "https://static-cos.lycheer.net/avatar/24399_f80f3ef8199ab2581affedf85ebf176e.jpg",
    "https://static-cos.lycheer.net/avatar/24400_5ab88ce21d5f04db4dc7fbcab5193a3b.jpg",
    "https://static-cos.lycheer.net/avatar/24401_8e886a7540b45a13dd3dc635f1f4cf99.jpg"
];

const names = [
    '平平',
    '妮儿',
    '花开不败',
    '万君祎',
    '亚静',
    '什悦菊',
    'JUN',
    'Jing',
    '幸福一生',
    '小谢',
    '安静',
    '一晨一诺',
    '梅',
    'Jin er',
    '彭涛',
    '...大萌子',
    '鏡音鈴',
    'Yilia',
    'hdjdjdx',
    'Keo',
    '汤乃凤',
    '于胜利',
    '芝心',
    '黃俊雄',
    '谢无名',
    'LLL',
    '里仁',
    '王华',
    '远方',
    '谭玉霞',
    '宝贝妈妈',
    '颂馨',
    '米不过分',
    '燕子',
    '|K0727',
    '吴定强',
    '曹海',
    'A老宋',
    '说',
    '冰',
    '清晨',
    '花丝娅',
    '主动加被动',
    '风（云）无阻',
    'summer',
    '猫咪',
    '畱歷',
    '郭玉春',
    '珍',
    '彩霞',
]

export {
    avatar_list,
    names,
}



// WEBPACK FOOTER //
// ./src/utils/avatar_list.js